<template>
    <div>
        <topback title="KYC Partner" path="back"></topback>
        <div class="mt-6">
            <kycpartnerlist></kycpartnerlist>
        </div>
        <md-button class="fixed-buttom" type="primary" round @click="go_addkyc">Add Kyc Partner</md-button>
    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import kycpartnerlist from '@/views/my/kycpartnerlist'


export default {
    name: 'kycpartner',
    components: {
        topback,
        iconimg,
        kycpartnerlist
    },

    data() {
        return {

        }
    },

    methods: {
      go_addkyc() {
        this.$router.push('/linkkycpartner');
      }
    }
}

</script>
<style scoped>
.fixed-buttom {
  position: fixed;
  bottom: 0.3rem;
  left: 50%;
  transform: translateX(-50%);
}
.partner .selector-header,
.partner .selector-footer {
  padding: 15px 40px;
  font-size: 16px;
  color: #ccc;
}

.partner .selector-item-body {
  display: flex;
  align-items: center;
}

.partner .selector-item-body.selected .selector-item-content {
  color: #2f86f6;
}

.partner .selector-item-body.disabled {
  opacity: .3;
}

.partner .selector-item-body .selector-item-left {
  flex-shrink: 0;
  margin-right: 32px;
}

.partner .selector-item-body .selector-item-left .holder {
  display: block;
  width: 88px;
  height: 88px;
  border-radius: 44px;
  background-color: #e6e6e6;
  font-size: 32px;
  font-weight: 500;
  color: #2f86f6;
  text-align: center;
  line-height: 88px;
}

.partner .selector-item-body .selector-item-content {
  flex: 1;
  color: #111a34;
  font-size: 32px;
  line-height: 1.2;
}

.partner .selector-item-body .selector-item-content .selector-item-title {
  line-height: 1.2;
}

.partner .selector-item-body .selector-item-content .selector-item-brief {
  color: #858b9c;
  font-size: 24px;
  line-height: 1.4;
  margin-top: 8px;
}



</style>



// WEBPACK FOOTER //
// src/views/my/kycpartner.vue